import { Injectable } from "@angular/core";
import { ITranslateObject, JobsBillingCard } from "../views-interfaces";
import { JOB_OWNER_COUNT_KEY } from "@services/index";
import { UsersFilterGeneratorService } from "./users-filter-generator.service";
import { MultiSelectModel, Option, type OptionValue } from "@app/filter-menu/filter-types";

@Injectable()
export class JobsOwnerFilterGeneratorService extends UsersFilterGeneratorService {
    protected override label: ITranslateObject = {
        "en-CA": "Job Owner",
        "fr-CA": "Chargé de mandat",
    };

    protected override visibilityCountKey = JOB_OWNER_COUNT_KEY;

    public override generateModel(selection: Option[]): MultiSelectModel {
        const model = super.generateModel(selection);
        const isNoneValue = (value: OptionValue): boolean => value === "-1" || value === -1;
        const sanitizedAllOptions = model.allOptions.filter((option) => !isNoneValue(option.value));
        const sanitizedApplicableOptions = model.applicableOptions.filter((option) => !isNoneValue(option.value));

        return {
            ...model,
            allOptions: sanitizedAllOptions,
            applicableOptions: sanitizedApplicableOptions,
            selection: model.selection.filter(
                (selected) => !isNoneValue(selected.value) && sanitizedApplicableOptions.some((option) => option.value === selected.value),
            ),
        };
    }

    public override generateFilter(selectedValues: OptionValue[]) {
        const sanitizedSelectedValues = (selectedValues ?? []).filter((value) => value !== "-1" && value !== -1);

        if (sanitizedSelectedValues.length === 0) {
            return null;
        } else {
            return (card: JobsBillingCard) => {
                const Id = card.job.owner;
                return sanitizedSelectedValues.includes(Id);
            };
        }
    }
}
